<!-- 
Created on April 28  2024
 网站登录
@author: xiaolong.li
  -->
<template>
  <!-- 李小龙 -->
  <div class="bgImg">
    <div class="outer">
      <div class="inner" style="display: flex">
        <div style="width: 300px; background-color: #0067b3">
          <div
            style="
              height: 90px;
              width: 200px;
              padding: 20px;
              padding-left: 30px;
            "
          >
            <img
              src="@/assets/logo.png"
              style="height: 100%; margin-left: 0px"
            />
          </div>
          <div>
            <div
              style="
                justify-content: center;
                align-items: center;
                padding-left: 20px;
              "
            >
              <div class="liginleft">{{ $t("login.库存超1500台叉车") }}</div>
              <div class="liginleft">{{ $t("login.超值折扣") }}</div>
              <div class="liginleft">{{ $t("login.快速交付") }}</div>
              <div class="liginleft">{{ $t("login.仅限叉车经销商使用") }}</div>
            </div>
          </div>
          <div
            style="
              justify-content: center;
              align-items: center;
              padding-left: 20px;
              padding: 30px;
            "
          >
            <a-button
              size="small"
              style="
                background-color: #ececec;
                height: 40px;
                width: 220px;
                font-size: 15px;
                color: black;
                cursor: hand;
              "
              @click="regist"
            >
              {{ $t("login.立即注册") }}
            </a-button>
          </div>
          <!-- <div>怎样注册</div> -->
        </div>
        <div
          style="
            flex: 1;
            background-color: #ffffff;
            padding: 60px;
            padding-left: 50px;
          "
        >
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            style="flex: 1"
          >
            <div
              style="width: 200px; justify-content: left; align-items: center"
            >
              <div style="font-size: 22px; font-weight: bold">登录</div>
              <div
                style="
                  margin-top: 20px;
                  color: #0067b3;
                  font-size: 12px;
                  font-weight: bold;
                "
              >
                {{ $t("login.电子邮箱") }}
              </div>
              <div style="margin-top: 10px">
                <a-form-model-item prop="email">
                  <a-input
                    style="width: 300px"
                    :placeholder="$t('login.请填写您的Email')"
                    v-model="form.email"
                    ref="email"
                  />
                </a-form-model-item>
              </div>
              <div
                style="
                  margin-top: -10px;
                  color: #0067b3;
                  font-size: 12px;
                  font-weight: bold;
                "
              >
                {{ $t("login.密码") }}
              </div>
              <div>
                <div style="margin-top: 10px">
                  <a-form-model-item prop="password">
                    <a-input
                      type="password"
                      style="width: 300px"
                      :placeholder="$t('login.请填写您的密码')"
                      v-model="form.password"
                      ref="password"
                    />
                  </a-form-model-item>
                </div>
              </div>
              <div style="padding: 0px 0px 0px 200px; justify-content: right">
                <a-button
                  icon="check"
                  size="small"
                  style="
                    padding: 0 0 0 10px;
                    background-color: #0067b3;
                    height: 40px;
                    width: 100px;
                    font-size: 15px;
                    color: white;
                    cursor: hand;
                  "
                  @click="login"
                >
                  {{ $t("login.登录") }}
                </a-button>
              </div>
              <div
                style="
                  padding: 10px 0px 0px 220px;
                  width: 400px;
                  cursor: pointer;
                "
              >
                <a @click="forget">{{ $t("login.忘记密码") }} </a>
              </div>
            </div>
          </a-form-model>
        </div>
      </div>
    </div>
    <forgotpwd ref="forgotpwdDlg"></forgotpwd>
    <top :userInfo="userInfo"></top>
  </div>
</template>

<script>
import axios from "axios";
import forgotpwd from "./forgotpwd.vue";
import top from "../basic/top.vue";
export default {
  components: { forgotpwd, top },
  data() {
    return {
      userInfo: "登录",
      visible: false,
      form: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    rules() {
      return {
        email: [
          {
            required: true,
            message: this.$t("login.请输入您的邮箱"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.请输入密码"),
            trigger: "blur",
          },
        ],
      };
    },
  },

  methods: {
    login() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          axios
            .post(this.$apiUrl + "/api/general/queryMulti", {
              tableName: "jf_web_user",
              filters: {
                queryFilter: [
                  {
                    dataIndex: "email",
                    operator: "eq", // eq 等于 neq 不等于
                    value: this.form.email,
                  },
                  {
                    dataIndex: "password",
                    operator: "eq", // eq 等于 neq 不等于
                    value: this.form.password,
                  },
                ],
              },
              offset: 0,
              limit: 10,
            })
            .then((res) => {
              if (res.data.errCode != 0) {
                this.$notification.error({
                  message: "登录失败",
                  description: "请联系系统管理员!",
                });
                return;
              } else {
                if (res.data.data.length == 0) {
                  this.$notification.error({
                    message: "登录失败",
                    description: "请检查用户名或密码是否正确?",
                  });
                  return;
                }
              }
              //登录成功
              //保存登录信息到vuex
              //保存到localStorage
              this.$store.dispatch("setMessage", res.data.data[0]);
              localStorage.setItem(
                "userJson",
                JSON.stringify(res.data.data[0])
              );

              this.$router.back();
            });
        }
      });
    },
    regist() {
      this.$router.push({ path: "/register", query: { editState: "Add" } });
    },
    forget() {
      this.$refs.forgotpwdDlg.show();
    },
  },
};
</script>

<style scoped>
.liginleft {
  padding: 10px;
  display: flex;
  justify-content: left;
  align-items: center;
  font-weight: 700 !important;
  --bs-text-opacity: 1;
  color: #ffffff !important;
}
.bgImg {
  width: 100%; /* 宽度100% */
  height: 100%; /* 高度100% */
  background-image: url("~@/assets/loginbg.png"); /* 引用assets目录下的图片 */
  background-size: cover; /* 背景图片覆盖整个div */
  background-position: center; /* 背景图片居中 */
}
.center-flex {
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 200px; /* 设置div的高度 */
  border: 1px solid #000; /* 边框仅为了可视化div的位置 */
}
.outer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 800px; /* 需要定义高度 */
}

.inner {
  width: 700px; /* 内嵌div的宽度 */
  height: 437px; /* 内嵌div的高度 */
  background-color: #f00; /* 背景颜色仅为了展示效果 */
}
</style>
